export default {"src":"/_next/static/media/zhaket-dark-logo.8782151c.svg","height":62,"width":87,"blurWidth":0,"blurHeight":0};